import {AbstractFindManyPaginatedService} from '../findmany/abstractFindManyPaginated.service';
import {Operator, Sort, UrlParameter} from '../../../../../../shared/utils/url.builder';
import {Pageable} from '../../../../../../shared/model/core/pageable.model';
import {Page} from '../../../../../../shared/model/core/page.model';
import {AbstractRepositoryV2} from '../../abstractRepositoryV2';
import {AbstractDataServiceAdapter} from '../../dataservice/adapter/abstractDataService.adapter';

export abstract class AbstractSearchService<StoredEntity, Entity> extends AbstractFindManyPaginatedService<StoredEntity, Entity> {

    protected static readonly DEFAULT_PAGE_SIZE = 10;
    private readonly attributeName: string;

    protected constructor(service: AbstractRepositoryV2<StoredEntity>,
                          dataService: AbstractDataServiceAdapter<StoredEntity, Entity, any>,
                          attributeName?: string,
                          parameters?: UrlParameter[]) {
        super(service, dataService, parameters);
        this.attributeName = attributeName;
    }


    search(text: string,
           attributeName?: string,
           sort?: Sort,
           pageSize?: number,
           additionalParameters?: UrlParameter[]): Promise<Page<Entity>> {

        if (!additionalParameters) {
            additionalParameters = [];
        }

        if (!attributeName && this.attributeName) {
            attributeName = this.attributeName;
        }

        if (attributeName && text) {
            additionalParameters.push(new UrlParameter(attributeName, text, Operator.LIKE));
        }
        return this.findPaginated(Pageable.ofWithSort(0, pageSize ? pageSize : AbstractSearchService.DEFAULT_PAGE_SIZE, sort), additionalParameters);
    }
}